import { initialState as boardInitialState } from 'src/store/action-methods/board'
import { initialState as boardsInitialState } from 'src/store/action-methods/boards'
import { initialState as collectionInitialState } from 'src/store/action-methods/collection'
import { initialState as modalInitialState } from 'src/store/action-methods/modal'
import { initialState as userInitialState } from 'src/store/action-methods/user'
import { initialState as bannerInitialState } from 'src/store/action-methods/banner'
import { initialState as routerInitialState } from 'src/store/router'
import { initialState as dataTableInitialState } from 'src/store/action-methods/dataTable'
import { initialState as snackBarInitialState } from 'src/store/action-methods/snackbar'
import { initialState as emojiInitialState } from 'src/store/action-methods/emoji'
import { initialState as conversationsInitialState } from 'src/store/action-methods/conversations'
import { initialState as adminInitialState } from 'src/store/action-methods/admin'
import { initialState as globalInitialState } from 'src/store/action-methods/global'
import { initialState as ltiInitialState } from 'src/store/action-methods/lti'

// No-op frontend change to exercise e2e CI for infrastructure updates.
export const initialState = {
  board: boardInitialState,
  boards: boardsInitialState,
  collection: collectionInitialState,
  global: globalInitialState,
  modal: modalInitialState,
  user: userInitialState,
  banner: bannerInitialState,
  router: routerInitialState,
  dataTable: dataTableInitialState,
  snackbar: snackBarInitialState,
  emoji: emojiInitialState,
  conversations: conversationsInitialState,
  admin: adminInitialState,
  lti: ltiInitialState
}
